import PropTypes from 'prop-types';
import React from 'react';
import $ from 'jquery';
import classNames from 'classnames';
import Textarea from './Textarea';
import Button from './Button';
import Avatar from './Avatar';

export default class CommentField extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasFocus: false,
            textValue: '',
            initialHeight: this.getButtonHeight(),
        };
        this.handleFocus = this.handleFocus.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    handleFocus(e) {
        this.props.onFocus(e);
        this.setState({
            hasFocus: true,
        });
    }

    handleSubmit(e) {
        var trimmedValue = this.state.textValue.trim();

        e.stopPropagation();
        e.preventDefault();

        if (trimmedValue) {
            this.props.onSubmit(trimmedValue);
        }
    }

    handleCancel(e) {
        e.stopPropagation();
        e.preventDefault();

        this.props.onCancel();
    }

    handleChange(e) {
        this.setState({
            textValue: e.target.value,
        });

        this.props.onChange(e);
    }

    handleKeyDown(e) {
        this.props.onKeyDown(e);
        // enter + (ctrl or cmd)
        if (e.keyCode === 13 && (e.ctrlKey || e.metaKey)) {
            return this.handleSubmit(e);
        }
    }

    // Hack to ensure input matches button height
    getButtonHeight() {
        var tmp = $('<button class="button button--primary">SAMPLE</button>').appendTo('body');
        var height = Math.ceil(tmp.outerHeight());
        tmp.remove();
        return height;
    }

    componentWillMount() {
        if (this.props.textValue) {
            this.setState({
                textValue: this.props.textValue,
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.textValue !== this.props.textValue) {
            this.setState({
                textValue: nextProps.textValue,
            });
        }
    }

    render() {
        var classes = classNames({
            'comment-field': true,
            'comment-field--vertical': this.props.layout === 'vertical',
            'comment-field--horizontal': this.props.layout === 'horizontal',
        });
        const fieldProps = this.getFieldProps();

        return (
            <div {...fieldProps} className={classes} data-comment-field>
                {this.avatar()}
                <div className="comment-field__input">
                    <Textarea
                        placeholder={this.props.placeholder}
                        isFocused={this.props.isAutoFocus}
                        value={this.state.textValue}
                        isExpandable={true}
                        onChange={this.handleChange}
                        onFocus={this.handleFocus}
                        onKeyDown={this.handleKeyDown}
                        onKeyUp={this.props.onKeyUp}
                        maxHeight={300}
                        minHeight={this.state.initialHeight}
                    />
                </div>
                {this.criticalError()}
                {this.buttons()}
            </div>
        );
    }
    getFieldProps() {
        if (this.props.hasFieldError) {
            return { 'data-field-error': true };
        }
    }
    avatar() {
        if (!this.props.activeUser) {
            return null;
        }

        return (
            <div className="comment-field__avatar">
                <Avatar user={this.props.activeUser} variations={['extra-small', 'block']} />
            </div>
        );
    }

    criticalError() {
        if (!this.props.criticalError) {
            return null;
        }

        return <div className="comment-field__error">{this.props.criticalError}</div>;
    }

    buttons() {
        if (this.props.isAutoFocus || this.state.hasFocus || this.state.textValue.length > 0) {
            return (
                <div className="comment-field__controls">
                    <div className="comment-field__button">
                        <Button
                            variations={['primary']}
                            isDisabled={Boolean(this.props.criticalError)}
                            title={this.props.submitButtonTooltip || null}
                            onClick={this.handleSubmit}
                            data-submit-comment-button
                        >
                            {this.props.submitButtonLabel}
                        </Button>
                    </div>
                    {this.cancelButton()}
                </div>
            );
        }
    }

    cancelButton() {
        if (!this.props.hasCancelButton) {
            return null;
        }

        return (
            <div className="comment-field__button">
                <Button
                    variations={['link']}
                    onClick={this.handleCancel}
                    data-cancel-comment-button
                >
                    {this.props.cancelButtonLabel}
                </Button>
            </div>
        );
    }
}

CommentField.propTypes = {
    cancelButtonLabel: PropTypes.string,
    hasCancelButton: PropTypes.bool,
    isAutoFocus: PropTypes.bool,
    layout: PropTypes.oneOf(['horizontal', 'vertical']),
    placeholder: PropTypes.string,
    submitButtonLabel: PropTypes.node,
    submitButtonTooltip: PropTypes.string,
    textValue: PropTypes.string,
    activeUser: PropTypes.object,
    onKeyDown: PropTypes.func,
    onKeyUp: PropTypes.func,
    onChange: PropTypes.func,
    onCancel: PropTypes.func,
    onSubmit: PropTypes.func,
    onFocus: PropTypes.func,
    criticalError: PropTypes.node,
    hasFieldError: PropTypes.bool,
};

CommentField.defaultProps = {
    cancelButtonLabel: '[CANCEL]',
    hasCancelButton: false,
    isAutoFocus: false,
    layout: 'horizontal',
    onCancel() {},
    onSubmit() {},
    onKeyDown() {},
    onKeyUp() {},
    onChange() {},
    onFocus() {},
    placeholder: '',
    submitButtonLabel: '[SEND]',

    criticalError: null,
};



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/CommentField.jsx